export default __webpack_public_path__ + "static/media/bell.97ebb290.svg";